import { selectedViewSelector } from "./selectedViewSelector";
import { filtersFromViewCombiner } from "./filtersFromViewCombiner";
import { RootState } from "../../../../store";

export const viewProductFamilyFilterSelector = (state: RootState) => {
  const view = selectedViewSelector(state);

  return filtersFromViewCombiner("product_family", view?.filters);
};
